import styled from "styled-components/macro";

export const FeatureHeader = styled.h2`
  font-family: Fjalla One, sans-serif;
  text-align: center;
  margin: 0;
  font-size: 2rem;
  font-weight: bold;
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const FeatureHeader2 = styled.h3`
  font-family: Fjalla One, sans-serif;
  text-align: center;
  margin: 0;
  font-size: 1.5rem;
  font-weight: bold;
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;
export const FeatureSection = styled.section`
  h1,
  h2 {
    font-family: Fjalla One, sans-serif;
    text-align: center;
    margin: 0;
    font-size: 2.5rem;
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  h3 {
    font-family: Fjalla One, sans-serif;
    text-align: center;
    margin: 0;
    font-size: 2rem;
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  h4 {
    font-family: Fjalla One, sans-serif;
    text-align: center;
    margin: 0;
    font-size: 1.5rem;
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  h5,
  h6 {
    font-family: Fjalla One, sans-serif;
    text-align: center;
    margin: 0;
    font-size: 1.25rem;
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  ul {
    padding: 1rem;
    list-style-type: disc;
    font-family: Roboto, sans-serif;
    font-size: 1.1rem;
    overflow-wrap: break-word;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    @media screen and (max-width: 900px) {
      font-size: 0.7rem;
    }
  }
  ol {
    padding: 1rem;
    list-style-type: decimal;
    font-family: Roboto, sans-serif;
    font-size: 1.1rem;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    overflow-wrap: break-word;
    @media screen and (max-width: 900px) {
      font-size: 0.7rem;
    }
  }

  p {
    font-family: Roboto, sans-serif;
    font-size: 1.1rem;
    margin: 1rem 0;
    overflow-wrap: break-word;

    @media screen and (max-width: 900px) {
      font-size: 0.8rem;
    }
  }
  a {
    color: blue;
    text-decoration: underline;
  }
`;

export const FeatureUl = styled.ul`
  padding: 1rem;
  margin: 0.5rem;
  list-style-type: disc;
  font-family: Roboto, sans-serif;
  font-size: 1.1rem;
`;

export const FeatureOl = styled.ol`
  padding: 1rem;
  margin: 0.5rem;
  list-style-type: decimal;
  font-family: Roboto, sans-serif;
  font-size: 1.1rem;
`;

export const FeatureParagraph = styled.p`
  font-family: Roboto, sans-serif;
  font-size: 1.1rem;
  margin: 1rem 0;

  @media screen and (max-width: 900px) {
    font-size: 0.8rem;
  }
`;
